import { FC } from 'react';
import { useStore } from '@hooks/useStore';
import { Switch } from '@components/Core/Switch/Switch';
import { StatusBadge } from '@components/Core/StatusBadge';
import InfoIcon from '@icons/inputs/info_icon.svg?component';
import { IEntityStatusRowProps } from './types';

export const EntityStatusRow: FC<IEntityStatusRowProps> = ({
  status,
  onChange,
  disabled = false,
  onIconClick,
}) => {
  const {
    popupStore: { openPopup },
  } = useStore();

  return (
    <div className="flex items-center gap-x-[16px]">
      {(status === 'Active' || status === 'Inactive') && (
        <Switch
          isActive={status === 'Active'}
          onChange={(status) => onChange(status ? 'Active' : 'Inactive')}
          disabled={disabled}
        />
      )}
      {status === 'Revise' && (
        <button type="button" onClick={() => (onIconClick ? onIconClick() : openPopup('status'))}>
          <InfoIcon />
        </button>
      )}
      <StatusBadge status={status} />
    </div>
  );
};
